<template>
  <div class="aside">
    <div class="aside_title">
      <img src="../../../assets/img/logo.png" alt="">
    </div>
    <el-menu
     @select="onMenuSelect"
      class="my-el-menu-no-border"
      background-color="#244CAB"
      text-color="#ffffff"
      active-text-color="#FFFFFF">
      <el-menu-item
        class="menu_item">
        <template slot="title">
          <i class="iconfont iconfukuanjilu" style="color:#ffffff; margin-right:20px"></i>
          <span>用户管理</span>
        </template>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
export default {
  methods: {
    // 选择某一菜单项
    onMenuSelect () {
      this.$router.push(`/index/admin`)
    }
  }
}
</script>
<style lang="scss" scoped>
  .aside {
    flex: none;
    width: 200px;
    height: 100%;
    background-color: $color-primary;
    overflow: hidden;
    .aside_title {
      display: flex;
      align-items: center;
      width: 100%;
      height: 60px;
      margin-bottom: 20px;
      padding-left: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/sidebar/index.vue